import RateConversationActionTypes from '../action-types/rate-conversation';
const INITIAL_STATE = {
    conversationStatus: {},
    isOpen: false,
    rate: undefined,
    rateHover: undefined,
    hostName: '',
};
const rateConversationReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RateConversationActionTypes.CLEAR_CONVERSATION_STATUS:
            return Object.assign(Object.assign({}, state), { conversationStatus: {} });
        case RateConversationActionTypes.SET_CONVERSATION_STATUS:
            return Object.assign(Object.assign({}, state), { conversationStatus: action.payload });
        case RateConversationActionTypes.SET_RATE_CONVERSATION_OPEN:
            return Object.assign(Object.assign({}, state), { isOpen: action.payload });
        case RateConversationActionTypes.SET_RATE:
            return Object.assign(Object.assign({}, state), { rate: action.payload });
        case RateConversationActionTypes.SET_RATE_HOVER:
            return Object.assign(Object.assign({}, state), { rateHover: action.payload });
        case RateConversationActionTypes.SET_HOST_NAME:
            return Object.assign(Object.assign({}, state), { hostName: action.payload });
        default:
            return state;
    }
};
export default rateConversationReducer;
